import React from 'react'
import FirebaseContext from "../../firebase/context";
import { Container, TableContainer, Table, TableHead, TableRow, TableCell, Typography, Button, TableBody } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import CompCicloListAdd from '../components/CompCicloListAdd';
import CompCicloList from '../components/CompCicloList';
import CompAdminUsuario from '../components/CompAdminUsuario';

const style = {
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        minHeight: 650
    },
};

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    table: {
        minWidth: 700,
    },
    tableHead: {
        // backgroundColor: theme.palette.common.primary,
        backgroundColor: "#29588F",
        // color: theme.palette.common.white,
        Color: "#f5f5f5",
    },
}));


const PagAdmUsuarios = () => {
    const classes = useStyles();

    const { firebase } = React.useContext(FirebaseContext);
    const [usuarios, setUsuarios] = React.useState([])
    const [alumnoUpdate, setAlumnoUpdate] = React.useState(false);

    React.useEffect(() => {
        console.log('me ejecutaron');

        getUsuarios();
    }, [alumnoUpdate]);

    function getUsuarios() {
        firebase.db.collection("colUsuarios").get().then(snapshot => {
            const arrayUsuarios = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            let usuariosOrdenados = arrayUsuarios
            usuariosOrdenados.sort(((a, b) => b.rol - a.rol));
            
            setUsuarios(usuariosOrdenados);
            setAlumnoUpdate(false)
        });
    }


    return (
        <Container style={style.cardGrid}>

            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead className={classes.tableHead}>
                        <TableRow>
                            <TableCell >
                                <Typography style={{ color: '#FFFFFF' }} >Nombre</Typography>
                            </TableCell>
                            <TableCell align="right">Email</TableCell>
                            <TableCell align="right">Rol</TableCell>
                            <TableCell align="right">seleccionar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {usuarios.map((usuario, index) => (
                            <CompAdminUsuario
                                key={usuario.id}
                                usuario={usuario}
                                index={index + 1}
                                setUsuarios={setUsuarios}
                                setAlumnoUpdate={setAlumnoUpdate}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    )
}

export default PagAdmUsuarios
